export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE as string;
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID as string;
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN as string;
export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL as string;
export const API_URL = process.env.REACT_APP_API_URL as string;
export const LWA_BETA_MODE = process.env.REACT_APP_LWA_BETA_MODE === 'true';
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID as string;
